import React, { useEffect, useState, useRef } from "react";

import { Radio, RadioGroup, FormControlLabel, Grid } from "@mui/material";
import { Box, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";

import {
  createSubUser,
  getCarearsByUserId,
  updateUserImageById,
} from "../../../Api/Services/UserServices";
import { PET_OWNER_ID_KEY, WORKSPACEID_KEY } from "../../../Constant";
import {
  FormHeaderBox,
  FormHeaderTitle,
  Body,
  Column,
  newSmallFieldBoxStyle,
  CancelButton,
  ButtonBoxStyle,
} from "../../../Css";
import { UserFormValidation } from "../../../From/Validation";
import CustomButton from "../../Common/Button";
import FormGroup from "../../Common/FormGroup";
import FormLayout from "../../Common/FormHeader";
import ImageUpload from "../../Common/ImageUpload";
import InputField from "../../Common/InputField";
import PasswordField from "../../Common/PasswordField";
import CustomPhoneInput from "../../Common/PhoneInput";
import { showSnackbar } from "../../Common/Snackbar";
import "react-phone-input-2/lib/style.css";
import { uploadS3Bucket } from "../../../Api/axios";
import { useTheme } from "@mui/material/styles";
import styled from "styled-components";
import PhoneInput from "../../../../Components/Common/PhoneInput";

const defaultValue = {
  first_name: "",
  last_name: "",
  email: "",
  role_id: "",
  password: "",
  membership_no: "",
  petowner_id: localStorage.getItem("pawprint_user_id"),
  phone_number: "",
  confPassword: "",
};

export default function UserForm() {
  let navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const membership_id = localStorage.getItem("membership_id");
  const user_id = localStorage.getItem(PET_OWNER_ID_KEY);
  const w_id = localStorage.getItem(WORKSPACEID_KEY);
  const theme = useTheme();

  const [image, setImage] = useState(null);
  const formikRef = useRef(null);

  // Separate function for generating membership number
  const generateMembershipNumber = async () => {
    try {
      const res = await getCarearsByUserId(w_id, user_id);
      const usersArray = res.data;
      const numberOfUsers = usersArray.data.length;

      let membership_no;
      let maxMembershipNo = 0;
      
      // If no users exist, append "001" to the membership ID
      if (numberOfUsers === 0) {
        membership_no = `${membership_id}-1-001`;
      } else {
        // Find the maximum membership number among existing users
        for (const user of usersArray.data) {
          const userMembershipNo = user.membership_no;
          if (userMembershipNo) {
            const [, , , , number] = userMembershipNo.split("-");
            const parsedNumber = parseInt(number, 10);
            maxMembershipNo = Math.max(maxMembershipNo, parsedNumber);
          }
        }
      }
      
      // Increment the maximum membership number and append it to the membership ID
      const nextNumber = (maxMembershipNo + 1).toString().padStart(3, "0");
      membership_no = `${membership_id}-1-${nextNumber}`;
      
      formikRef?.current?.setFieldValue("membership_no", membership_no);
      return membership_no;
    } catch (err) {
      console.error("Error generating membership number:", err);
      throw err;
    }
  };

  // Separate function for creating user with image upload
  const createUserWithImage = async (userData, userId) => {
    if (!image) return;

    try {
      const updateData = {
        type: image?.type,
        file_name: `${Date.now()}-${image?.name}`,
      };
      
      const res2 = await updateUserImageById(userId, updateData);
      const url = res2?.data?.url;
      const decodedUrl = decodeURIComponent(url);
      
      const uploadRes = await uploadS3Bucket(decodedUrl, image);
      if (uploadRes?.status === 200) {
        console.log("Image upload successful:", uploadRes);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  };

  // Separate function for API call
  const createUser = async (values) => {
    const newUserData = {
      ...values,
      w_id: w_id,
    };
    delete newUserData?.confPassword;
    
    const res = await createSubUser(newUserData);
    
    if (res?.data?.message === "This email already exist.") {
      throw new Error("This email already exist.");
    }
    
    return res;
  };

  useEffect(() => {
    generateMembershipNumber().catch((err) => {
      console.error("Failed to generate membership number:", err);
    });
  }, [membership_id, user_id, w_id]);

  // Clean async handleSubmit function
  const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
    try {
      // Create user
      const userResponse = await createUser(values);
      
      // Upload image if exists
      if (image && userResponse?.data?.data?.id) {
        await createUserWithImage(values, userResponse.data.data.id);
      }
      
      // Show success message
      showSnackbar({
        type: "success",
        message: "New user has been created successfully.",
        closeOnClick: true,
      });
      
    } catch (err) {
      console.error("Error creating user:", err);
      
      if (err.message === "This email already exist.") {
        setFieldError("email", "This email already exist.");
      } else {
        showSnackbar({
          type: "error",
          message: "Failed to create user. Please try again.",
          closeOnClick: true,
        });
      }
    } finally {
      setSubmitting(false);
    }
  };

  const borderColor =
    formikRef?.current?.values?.role_id !== "" &&
    formikRef?.current?.touched?.role_id &&
    formikRef?.current?.errors?.role_id
      ? "#d32f2f"
      : `${theme.palette.primary.main}`;
  const styles = {
    radio: {
      "& .MuiRadio-root": {
        color: `${borderColor}`,
        "&.Mui-checked": {
          color: `${borderColor}`,
        },
      },
    },
  };

  const Country = styled.div`
  .react-tel-input .form-control {
    padding-top: 0 !important;
    border: 1px solid ${theme.palette.primary.main} !important;
    border-radius: 6px !important;
    // height: 38px !important;
    width: ${(props) => props.width || "100% !important"};
    // box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25) !important;
    background: #FFF !important;
  }

  .react-tel-input :disabled {
    border: 1px solid rgba(0, 0, 0, 0.26) !important;
  }

  @media (max-width: 1220px) {
    .react-tel-input .form-control {
      width: 100% !important;
    }
  }
  @media (max-width: 900px) {
    .react-tel-input .form-control {
      width: 100% !important;
    }
  }
  @media (max-width: 600px) {
    .react-tel-input .form-control {
      width: 100% !important;
    }
  }

  .react-tel-input .flag-dropdown {
    top: 0;
    bottom: 0;
    padding: 0;
    background-color: transparent !important;
    border: transparent !important;
    border-radius: 3px 0 0 3px;
  }

  input:-internal-autofill-selected {
    background-image: none !important;
    background: rgba(255, 255, 255, 0.2) !important;
    color: fieldtext !important;
  }
`;

  return (
    <FormLayout title="User Information">
      <Formik
        initialValues={defaultValue}
        innerRef={formikRef}
        onSubmit={handleSubmit}
        validationSchema={UserFormValidation}
        validateOnMount={false}
      >
        {({ getFieldProps, values, isSubmitting, errors, setFieldValue }) => (
          <Form>
            <Box sx={FormHeaderBox(theme.palette.primary.main)}>
              <Box
                sx={{
                  borderBottom: `1px solid ${theme.palette.primary.main}`,
                  width: "100%",
                }}
              >
                <Typography variant="h6" sx={FormHeaderTitle}>
                  User Details
                </Typography>
              </Box>
              <div className="scroll2" style={{ width: "100%" }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    justifyContent: "center",
                  }}
                >
                  <ImageUpload
                    alt="Uploaded_Image"
                    id="imageInput"
                    image={image}
                    setImage={setImage}
                    accept="image/*"
                    width="150px"
                    height="150px"
                  />
                </Box>
                <Body style={{ gap: "10px 20px" }}>
                  <Column>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={6}>
                        <FormGroup
                          name="first_name"
                          label={"First Name"}
                          requiredField
                        >
                          <InputField {...getFieldProps("first_name")} />
                        </FormGroup>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormGroup
                          name="last_name"
                          label={"Last Name"}
                          requiredField
                        >
                          <InputField {...getFieldProps("last_name")} />
                        </FormGroup>
                      </Grid>
                    </Grid>
                  </Column>
                  <Column style={{ gap: "21px", height: "max-content" }}>
                    <FormGroup
                      name="email"
                      label={"Email Address"}
                      requiredField
                    >
                      <InputField {...getFieldProps("email")} />
                    </FormGroup>
                  </Column>
                  <Column>
                    <FormGroup
                      name="phone_number"
                      label={"Phone Number"}
                    >
                      <Country>
                        <PhoneInput
                          dialCodeName="phone_code"
                          name="phone_number"
                          onChange={(value, country) => {                          
                            setFieldValue("phone_number", value);
                          }}
                        />
                      </Country>
                    </FormGroup>
                  </Column>
                  <Column>
                    <FormGroup name="role_id" label={"Role"} requiredField>
                      <RadioGroup
                        name="role_id"
                        {...getFieldProps("role_id")}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          color: "white",
                        }}
                        sx={styles.radio}
                      >
                        <FormControlLabel
                          value="2"
                          control={<Radio />}
                          label="General Authorized User"
                          sx={{
                            "& .MuiTypography-root": {
                              fontSize: "0.9rem",
                              color: "black",
                            },
                          }}
                        />
                        <FormControlLabel
                          value="4"
                          control={<Radio />}
                          label="View Only User"
                          sx={{
                            "& .MuiTypography-root": {
                              fontSize: "0.9rem",
                              color: "black",
                            },
                          }}
                        />
                      </RadioGroup>
                    </FormGroup>
                  </Column>
                  <Column style={{ height: "max-content" }}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={6}>
                        <FormGroup
                          name="password"
                          label={"Password"}
                          requiredField
                        >
                          <PasswordField {...getFieldProps("password")} />
                        </FormGroup>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormGroup
                          name="confPassword"
                          label={"Confirm Password"}
                          requiredField
                        >
                          <PasswordField
                            {...getFieldProps("confPassword")}
                            onCut={(e) => e.preventDefault()}
                            onCopy={(e) => e.preventDefault()}
                            onPaste={(e) => e.preventDefault()}
                          />
                        </FormGroup>
                      </Grid>
                    </Grid>
                  </Column>
                </Body>
              </div>
              <Box sx={ButtonBoxStyle(`${theme.palette.primary.main}`)}>
                <CustomButton
                  label="Cancel"
                  type="button"
                  style={CancelButton(`${theme.palette.primary.main}`)}
                  onClick={() => navigate(-1)}
                />
                <CustomButton
                  label={isSubmitting ? "Saving..." : "Save"}
                  type="submit"
                />
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
    </FormLayout>
  );
}
